import styled, { css } from "styled-components";

import { bettoSelectedSurface } from "../bettoSelectedSurface";

const glassCardBorder = css`
	isolation: isolate;

	&::after {
		content: "";
		position: absolute;
		inset: 0;
		border-radius: inherit;
		border: 1px solid #ffffff;
		mix-blend-mode: overlay;
		pointer-events: none;
		z-index: 2;
	}
`;

export const BettoProviderTriggerGroup = styled.div`
	display: inline-flex;
	align-items: center;
	flex: 0 0 auto;
	flex-shrink: 0;
`;

export const BettoProviderTrigger = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 4px;
	flex: 0 0 auto;
	flex-shrink: 0;
	align-self: center;
	box-sizing: border-box;
	width: max-content;
	max-width: max-content;
	height: 38px;
	padding: 0 12px;
	border: none;
	border-radius: 10px;
	background: transparent;
	color: #abb4cf;
	font-family: inherit;
	font-size: 14px;
	font-weight: 400;
	line-height: 1;
	cursor: pointer;
	white-space: nowrap;
	position: relative;
	isolation: isolate;
	overflow: hidden;
	transition:
		background 0.2s ease,
		color 0.2s ease;

	${({ $active }) =>
		$active &&
		css`
			${bettoSelectedSurface}
		`}

	&:hover:not(:disabled) {
		background: #202534;
		color: #e5f0fe;
	}

	span {
		display: inline-flex;
		align-items: center;
		line-height: 1;
	}
`;

export const BettoProviderTriggerIcon = styled.img`
	flex-shrink: 0;
	align-self: center;
	display: block;
	width: 14px;
	height: 14px;
	object-fit: contain;
`;

export const BettoProviderTriggerClear = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 38px;
	height: 38px;
	margin-left: -6px;
	padding: 0;
	border: none;
	border-radius: 10px;
	background: transparent;
	color: #abb4cf;
	font-size: 18px;
	line-height: 1;
	cursor: pointer;
	flex-shrink: 0;
	transition:
		background 0.2s ease,
		color 0.2s ease;

	${({ $active }) =>
		$active &&
		css`
			background: #202534;
			color: #e5f0fe;
		`}

	&:hover {
		background: #202534;
		color: #e5f0fe;
	}
`;

export const BettoProviderRoot = styled.div`
	position: fixed;
	inset: 0;
	z-index: 10000;
	display: ${({ $open }) => ($open ? "flex" : "none")};
	flex-direction: column;
	align-items: center;
`;

export const BettoProviderOverlay = styled.button`
	position: absolute;
	inset: 0;
	border: none;
	padding: 0;
	background: rgba(5, 8, 16, 0.97);
	backdrop-filter: blur(8px);
	cursor: pointer;
`;

export const BettoProviderPanel = styled.div`
	position: relative;
	z-index: 1;
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 1104px;
	height: 100%;
	padding: 24px 16px 32px;
	overflow-y: auto;
	box-sizing: border-box;

	@media (min-width: 768px) {
		padding: 32px 24px 40px;
	}
`;

export const BettoProviderHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	margin-bottom: 24px;
`;

export const BettoProviderTitleGroup = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	min-width: 0;
`;

export const BettoProviderTitle = styled.h2`
	margin: 0;
	color: #e5f0fe;
	font-family: var(--bt-font-family);
	font-size: 22px;
	font-weight: 600;
	line-height: 1.1;
	letter-spacing: -1.32px;
`;

export const BettoProviderCount = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 24px;
	height: 24px;
	padding: 0 8px;
	border-radius: 12px;
	background: #2c313c;
	color: #e5f0fe;
	font-family: var(--bt-font-family);
	font-size: 12px;
	font-weight: 600;
	line-height: 1;
`;

export const BettoProviderCloseButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 34px;
	height: 34px;
	padding: 8px;
	border: none;
	border-radius: 10px;
	background: #2b3245;
	color: #e5f0fe;
	cursor: pointer;

	svg {
		display: block;
		width: 16px;
		height: 16px;
	}
`;

export const BettoProviderSearchSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 100%;
	margin-bottom: 24px;
`;

export const BettoProviderSearchBar = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	width: 100%;
	min-height: 52px;
	padding: 0 14px;
	box-sizing: border-box;
	border-radius: 10px;
	border: 1px solid ${({ $focused }) => ($focused ? "#0362d4" : "#343946")};
	background: #1f2536;
`;

export const BettoProviderSearchIcon = styled.img`
	flex-shrink: 0;
	display: block;
	width: 24px;
	height: 24px;
`;

export const BettoProviderSearchInput = styled.input`
	flex: 1;
	min-width: 0;
	border: none;
	outline: none;
	background: transparent;
	color: #e5f0fe;
	font-family: var(--bt-font-family);
	font-size: 14px;
	font-weight: 400;
	line-height: 1.4;

	&::placeholder {
		color: #858faf;
	}
`;

export const BettoProviderClearButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 24px;
	height: 24px;
	padding: 0;
	border: none;
	background: transparent;
	color: #858faf;
	cursor: pointer;
	font-size: 18px;
	line-height: 1;
`;

export const BettoProviderInfo = styled.p`
	margin: 0;
	color: #858faf;
	font-family: var(--bt-font-family);
	font-size: 12px;
	font-weight: 400;
	line-height: 1.4;
`;

export const BettoProviderGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 12px;
	width: 100%;

	@media (min-width: 640px) {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}

	@media (min-width: 900px) {
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}

	@media (min-width: 1100px) {
		grid-template-columns: repeat(5, minmax(0, 1fr));
	}
`;

export const BettoProviderCard = styled.button`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	justify-content: flex-start;
	gap: 10px;
	padding: 12px;
	border: 1px solid ${({ $active }) => ($active ? "#0362d4" : "transparent")};
	border-radius: 14px;
	background: ${({ $active }) => ($active ? "rgba(3, 98, 212, 0.14)" : "#171c2a")};
	cursor: pointer;
	text-align: left;
	overflow: hidden;
	transition:
		background 0.2s ease,
		border-color 0.2s ease,
		transform 0.2s ease;
	${glassCardBorder}

	&:hover:not(:disabled) {
		background: ${({ $active }) => ($active ? "rgba(3, 98, 212, 0.2)" : "#1f2536")};
		border-color: ${({ $active }) => ($active ? "#0362d4" : "#343946")};
		transform: translateY(-2px);
	}
`;

export const BettoProviderLogoWrap = styled.div`
	position: relative;
	width: 100%;
	aspect-ratio: 196 / 80;
	overflow: hidden;
	border-radius: 10px;
	background: #171c2a;

	img {
		position: absolute;
		inset: 0;
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: inherit;
	}
`;

export const BettoProviderCardFooter = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	width: 100%;
	min-width: 0;
`;

export const BettoProviderName = styled.span`
	flex: 1;
	min-width: 0;
	color: #e5f0fe;
	font-family: var(--bt-font-family);
	font-size: 12px;
	font-weight: 500;
	line-height: 1.2;
	letter-spacing: -0.24px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const BettoProviderGameCount = styled.span`
	flex-shrink: 0;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 28px;
	height: 22px;
	padding: 0 6px;
	border-radius: 11px;
	background: #2c313c;
	color: #abb4cf;
	font-family: var(--bt-font-family);
	font-size: 11px;
	font-weight: 600;
	line-height: 1;

	${BettoProviderCard}[data-active="true"] &,
	${BettoProviderCard}:hover & {
		background: rgba(255, 255, 255, 0.12);
		color: #e5f0fe;
	}
`;
